import { render, staticRenderFns } from "./logActivityDetail.vue?vue&type=template&id=3992f8f0&"
import script from "./logActivityDetail.vue?vue&type=script&lang=js&"
export * from "./logActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports